import { useState, useEffect } from "react";

const useProgressiveImg = (src) => {
  const [isLoading, setIsLoading] = useState(true);

  const onLoadImage = () => {
    setIsLoading(false);
  };

  const imgLoadingCheck = () => {
    setIsLoading(true);

    // Handle image loading
    if (src) {
      const img = new Image();
      img.src = src;
      img.onload = onLoadImage;
    }
  };

  useEffect(() => {
    imgLoadingCheck();
  }, [src]);

  return { isLoading };
};

export default useProgressiveImg;
